import { Banner, DocumentField, EnumChip, Placeholder } from '@if/mui'
import { Box, Link, Stack } from '@mui/material'
import { MerchantUserRow } from '@src/data/api/user-api/user-api'
import { EAccountStatus } from '@src/types/enumSets'
import { useTranslation } from 'react-i18next'

interface Props {
  user: MerchantUserRow
  /** True when the pending action is (re)activation, false when it's a deactivation. */
  activating: boolean
}

/**
 * Body of the Manage-user confirm dialog: the user's details (label/value rows)
 * followed by a banner explaining what the pending activate/deactivate action does.
 */
const ManageUserDialogContent = ({ user, activating }: Props) => {
  const { t } = useTranslation()
  const jobTitle =
    user.jobTitle && user.jobTitle !== '—' ? user.jobTitle : <Placeholder>{t('common.notProvided')}</Placeholder>

  return (
    <Stack spacing={2}>
      <Box>
        <DocumentField label={t('common.firstName')} value={user.firstName} />
        <DocumentField label={t('common.lastName')} value={user.lastName} />
        <DocumentField
          label={t('UserStatsHeaders.accountStatus')}
          value={
            <EnumChip
              set={EAccountStatus}
              value={user.accountEnabled ? EAccountStatus.Active : EAccountStatus.Inactive}
            />
          }
        />
        <DocumentField label={t('UserStatsHeaders.jobTitle')} value={jobTitle} />
        <DocumentField
          label={t('common.phone')}
          value={
            user.phone ? (
              <Link component="a" href={`tel:${user.phone}`}>
                {user.phone}
              </Link>
            ) : (
              ''
            )
          }
        />
        <DocumentField
          label={t('common.email')}
          value={
            user.email ? (
              <Link component="a" href={`mailto:${user.email}`}>
                {user.email}
              </Link>
            ) : (
              ''
            )
          }
        />
      </Box>
      <Banner severity={activating ? 'info' : 'error'}>
        {t(activating ? 'common.activateWarning' : 'common.deactivateWarning', { name: user.fullName })}
      </Banner>
    </Stack>
  )
}

export default ManageUserDialogContent
